import React, { useEffect } from "react";
import { Typography, CircularProgress } from "@material-ui/core";
import { useTranslation } from "react-i18next";

export default function ModalPaymentProcessing({ open, onClose }) {
	const { t } = useTranslation();

	useEffect(() => {
		if (open) {
			document.body.style.overflow = "hidden";
		} else {
			document.body.style.overflow = "unset";
		}

		return () => {
			document.body.style.overflow = "unset";
		};
	}, [open]);

	if (!open) return null;

	const handleBackdropClick = (e) => {
		if (e.target === e.currentTarget) {
			onClose();
		}
	};

	return (
		<>
			<div
				onClick={handleBackdropClick}
				style={{
					position: "fixed",
					top: 0,
					left: 0,
					right: 0,
					bottom: 0,
					backgroundColor: "rgba(0, 0, 0, 0.5)",
					zIndex: 1299,
				}}
			>
				<div
					style={{
						position: "absolute",
						top: "50%",
						left: "50%",
						transform: "translate(-50%, -50%)",
						width: "100%",
						maxWidth: 320,
						backgroundColor: "#fff",
						borderRadius: 20,
						padding: 24,
						boxShadow: "0px 4px 16px rgba(0,0,0,0.25)",
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						textAlign: "center",
					}}
				>
					<div
						style={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							width: "100%",
							marginBottom: 12,
						}}
					>
						<div style={{ width: 24 }} />
						<Typography
							style={{
								fontWeight: 700,
								fontSize: "clamp(16.5px, 2vw, 20px)",
								color: "#333333",
							}}
						>
							{t("Pagamento em processamento")}
						</Typography>
					</div>

					<Typography
						style={{
							fontSize: "clamp(14px, 1.8vw, 16px)",
							color: "#555",
							marginBottom: 16,
						}}
					>
						{t("Aguarde estamos finalizando seu pagamento")}
					</Typography>

					<CircularProgress size={28} />
				</div>
			</div>
		</>
	);
}

